import { queryOptions } from '@tanstack/react-query'
import { parseISO, differenceInHours } from 'date-fns'
import { CARRIER_PREFIX, deleteRequest, getRequest, postRequest } from 'global/helpers/requests'
import { sleep } from 'global/helpers/sleep'
import { type VehicleData, type CreateOrEditVehicleFormValues, VehicleType } from './VehicleManager.types'

export const VEHICLES_QUERY_KEY = 'vehicles'

export const getVehicles = async (): Promise<VehicleData[]> => {
  const vehicles = await getRequest<VehicleData[]>('vehicles', {}, CARRIER_PREFIX)
  return vehicles.map(processVehicle).sort(sortVehicles)
}

export const vehiclesQueryOptions = queryOptions({
  queryKey: [VEHICLES_QUERY_KEY],
  queryFn: getVehicles,
})

export const createVehicle = async (data: CreateOrEditVehicleFormValues): Promise<void> => {
  const response = await postRequest<void>('vehicles', { body: data }, CARRIER_PREFIX)
  await sleep(1000) // needed until backend is reworked to do synchronous updates
  return response
}

export const editVehicle = async ({ licensePlate, vehicleType, data }: {
  licensePlate: string,
  vehicleType: VehicleType,
  data: CreateOrEditVehicleFormValues
}): Promise<void> => {
  const response = await postRequest<void>(`vehicles/${licensePlate}/${vehicleType}`, { body: data }, CARRIER_PREFIX)
  await sleep(1000) // needed until backend is reworked to do synchronous updates
  return response
}

export const deleteVehicle = async ({ licensePlate, vehicleType }: {
  licensePlate: string,
  vehicleType: VehicleType,
}): Promise<void> => {
  const response = await deleteRequest<void>(`vehicles/${licensePlate}/${vehicleType}`, {}, CARRIER_PREFIX)
  await sleep(1000) // needed until backend is reworked to do synchronous updates
  return response
}

const processVehicle = (vehicle: VehicleData): VehicleData => {
  if (vehicle.lastPositionTimestamp) {
    if (differenceInHours(new Date(), parseISO(vehicle.lastPositionTimestamp)) <= 24) {
      vehicle.status = 'online'
    } else {
      vehicle.status = 'offline'
    }

  }
  return vehicle
}

const sortVehicles = (a: VehicleData, b: VehicleData): number =>
  a.licensePlate.localeCompare(b.licensePlate)
